module.exports = __webpack_public_path__ + "img/06.67179ffb.png";